import { render, staticRenderFns } from "./Salesorder.vue?vue&type=template&id=e0aa6e6e&scoped=true&"
import script from "./Salesorder.vue?vue&type=script&lang=js&"
export * from "./Salesorder.vue?vue&type=script&lang=js&"
import style0 from "./Salesorder.vue?vue&type=style&index=0&id=e0aa6e6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0aa6e6e",
  null
  
)

export default component.exports